import { Stack, Typography, useTheme } from "@mui/material";
import AfternoonIcon from "assets/images/greetings/afternoon.svg";
import MidDayIcon from "assets/images/greetings/midday.svg";
import MorningIcon from "assets/images/greetings/morning.svg";
import NightIcon from "assets/images/greetings/night.svg";
import { useGlobalStore } from "controller";
import { useEffect, useState } from "react";
import { dayjs } from "utilz/dayjs";

const GREETINGS = {
  morning: {
    icon: MorningIcon,
    label: "Morning",
    message: (name: string) =>
      name ? `Rise and shine, ${name}` : "Rise and shine",
  },
  midday: {
    icon: MidDayIcon,
    label: "Midday",
    message: (name: string) =>
      name
        ? `Hope your day's going well, ${name}`
        : "Hope your day's going well",
  },
  afternoon: {
    icon: AfternoonIcon,
    label: "Afternoon",
    message: (name: string) =>
      name ? `Good afternoon, ${name}` : "Good afternoon",
  },
  earlyEvening: {
    icon: AfternoonIcon,
    label: "Evening",
    message: (name: string) => (name ? `Evening, ${name}` : "Evening"),
  },
  evening: {
    icon: NightIcon,
    label: "Evening",
    message: (name: string) => (name ? `Evening, ${name}` : "Evening"),
  },
  lateNight: {
    icon: NightIcon,
    label: "Late night",
    message: (name: string) =>
      name ? `Working late, ${name}?` : "Working late?",
  },
} as const;

const getGreeting = (hour: number) => {
  if (hour >= 5 && hour < 10) return GREETINGS.morning;
  if (hour >= 10 && hour < 13) return GREETINGS.midday;
  if (hour >= 13 && hour < 17) return GREETINGS.afternoon;
  if (hour === 17) return GREETINGS.earlyEvening;
  if (hour >= 18 && hour < 21) return GREETINGS.evening;
  return GREETINGS.lateNight;
};

export const GreetingsSection = () => {
  const theme = useTheme();
  const firstName = useGlobalStore((state) => state.firstName);
  const timezone = useGlobalStore((state) => state.timezone);
  const [now, setNow] = useState(() => dayjs().tz(timezone));

  // Keep the clock in sync with the user's timezone, ticking every minute.
  useEffect(() => {
    setNow(dayjs().tz(timezone));
    const intervalId = setInterval(() => {
      setNow(dayjs().tz(timezone));
    }, 60000);

    return () => clearInterval(intervalId);
  }, [timezone]);

  const { icon, label, message } = getGreeting(now.hour());

  return (
    <Stack direction="row" sx={{ alignItems: "center", gap: "12px" }}>
      <img src={icon} alt={label} width={40} height={40} />
      <Stack sx={{ gap: "2px" }}>
        {/* The greeting always addresses the signed-in user — whose numbers are
            on screen is stated by the Overview heading instead. */}
        <Typography variant="h6" color={theme.palette.lightBg.high}>
          {message(firstName ?? "")}
        </Typography>
        <Typography variant="body-xsmall" color={theme.palette.lightBg.low}>
          {`${now.format("MMMM D, YYYY")} • ${now.format("h:mm A")}`}
        </Typography>
      </Stack>
    </Stack>
  );
};
